import { default as safeModeMarkup } from './safeModeMarkup.html';
import { default as safeModeMarkupBinge } from './safeModeMarkupBinge.html';
import { default as safeModeMarkupFoxsports } from './safeModeMarkupFoxsports.html';
import { default as safeModeMarkupFoxtelgnc } from './safeModeMarkupFoxtelgnc.html';
import { default as safeModeMarkupKayo } from './safeModeMarkupKayo.html';

export const safeModeMarkups = {
    dazn: safeModeMarkup,
    binge: safeModeMarkupBinge,
    kayo: safeModeMarkupKayo,
    foxtelgnc: safeModeMarkupFoxtelgnc,
    foxsports: safeModeMarkupFoxsports,
};
